export enum GoogleAddressComponent {
  StreetNumber = 'street_number',
  Street = 'route',
  City = 'locality',
  AlternateCity = 'administrative_area_level_2',
  State = 'administrative_area_level_1',
  Country = 'country',
  Zip = 'postal_code',
  CountryCode = 'countryCode',
}
